export const OfflineChip = (): JSX.Element => (
  <div className="flex w-fit items-center rounded-full bg-gray-100 px-3 py-1 text-center text-sm text-red">
    Offline
  </div>
);
